module.exports = __webpack_public_path__ + "img/zy.daae42b4.svg";